import React from 'react'
import { useMediaQuery, ThemeProvider, CssBaseline } from '@material-ui/core'
import getTheme from 'app/resources/styles/theme'
import { Layout } from './layout'
import { BrowserRouter as Router } from 'react-router-dom'

import Routes from './routes/routes'
import { ErrorBoundary } from './shared/components/error-boundary'
import { MediaQueryProvider } from './shared/components/mediaqueryprovider'
import { IsBusyContextProvider } from './shared/state/is-busy-context'
import { UserContextProvider } from './shared/state/user-context'
import { ToastContextProvider } from './shared/state/toast-context'
import { SaveIndicatorContextProvider } from './shared/state/save-indicator-context'
import { ThemeContextProvider } from './shared/state/theme-context'
import { AppContextProvider } from './app-context/app-context'

const App = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: light)')
  const mobileView = useMediaQuery('(max-width: 600px)')

  const theme = React.useMemo(() => {
    return getTheme(prefersDarkMode, mobileView)
  }, [prefersDarkMode, mobileView])

  return (
    <AppContextProvider>
      <MediaQueryProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <IsBusyContextProvider>
              <SaveIndicatorContextProvider>
                <UserContextProvider>
                  <ToastContextProvider>
                    <ThemeContextProvider>
                      <Layout>
                        <Routes />
                      </Layout>
                    </ThemeContextProvider>
                  </ToastContextProvider>
                </UserContextProvider>
              </SaveIndicatorContextProvider>
            </IsBusyContextProvider>
          </Router>
        </ThemeProvider>
      </MediaQueryProvider>
    </AppContextProvider>
  )
}

const AppWrapper = () => {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  )
}

export default AppWrapper
